import React from "react";
import { useSelector } from "react-redux";
import { useWatch } from "react-hook-form";

import { i18, trb } from "@utilities";
import {
  AddRemoveInputs,
  FullWidthInputWrapper,
  HalfWidthInputWrapper,
  StepperFormRow
} from "@components";
import { CheckboxFormField } from "@components/FormField/HookFormFields";
import { selectPEN } from "@redux";
import { MainCustomer } from "../elements/MainCustomer";

export const MainCustomers = ({ control, unregister, totalCustomers, setTotalCustomers }) => {
  const PEN = useSelector(selectPEN);
  const customerEmpty = useWatch({
    control,
    name: "mainCustom.0.customerEmpty"
  });
  const retail = useWatch({
    control,
    name: "mainCustom.0.retail"
  });

  const onCheckboxClick = e => {
    if (!e.target.checked) return;
    if (totalCustomers > 1) {
      for (let i = 1; i < totalCustomers; i++) {
        unregister(`mainCustom.${i}`);
      }
      unregister("mainCustom.0.data");
    } else {
      unregister("mainCustom.0.data");
    }
  };

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-part-note">{trb(i18.Labels.SpecifyCustomers)}</p>
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <CheckboxFormField
          control={control}
          name="mainCustom.0.customerEmpty"
          label={trb(i18.Labels.CustomerEmpty)}
          onChange={onCheckboxClick}
          defaultValue={false}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <CheckboxFormField
          control={control}
          name="mainCustom.0.retail"
          label={trb(i18.Labels.Retail)}
          onChange={onCheckboxClick}
          defaultValue={false}
        />
      </HalfWidthInputWrapper>
      {(!customerEmpty || customerEmpty === "0") && (!retail || retail === '0') && (
          <>
            {new Array(totalCustomers).fill(null).map((_, index) => (
              <MainCustomer control={control} customerIndex={index} key={PEN[index]?.value} />
            ))}
            <AddRemoveInputs
              totalInputsAdded={totalCustomers}
              maxInputsAllowed={PEN.length}
              onAdd={() => setTotalCustomers(prev => prev + 1)}
              onRemove={() => {
                unregister(`mainCustom.${totalCustomers - 1}`);
                setTotalCustomers(prev => prev - 1);
              }}
            />
          </>
        )}
    </StepperFormRow>
  );
};
